import React, { useState } from 'react';
import DashboardLayout from './components/layout/DashboardLayout';
import Sidebar from './components/navigation/Sidebar';
import TopBar from './components/navigation/TopBar';
import KPISection from './components/dashboard/KPISection';
import ContentGrid from './components/dashboard/ContentGrid';
import PlantLevelView from './components/modals/PlantLevelView';
import CustomerPLView from './components/modals/CustomerPLView';
import ProductLineBreakdown from './components/modals/ProductLineBreakdown';
import WarrantyRootCauseView from './components/modals/WarrantyRootCauseView';
export function App() {
  const [activeSection, setActiveSection] = useState('Overview');
  // Filter state
  const [filters, setFilters] = useState({
    dateRange: 'Last 12 Months',
    region: 'All India',
    businessUnit: 'All Units',
    productLine: 'All Products',
    customer: 'All Customers',
    timePeriod: 'Monthly'
  });
  // Cross-highlighting state
  const [selectedItem, setSelectedItem] = useState<{
    type: string | null;
    value: string | null;
  }>({
    type: null,
    value: null
  });
  // Drilldown modal state
  const [drilldownModal, setDrilldownModal] = useState<{
    type: string | null;
    data: any;
  }>({
    type: null,
    data: null
  });
  // Handle filter changes
  const handleFilterChange = (filterType: string, value: string) => {
    setFilters({
      ...filters,
      [filterType]: value
    });
    // Clear selection when filters change
    setSelectedItem({
      type: null,
      value: null
    });
  };
  // Handle item selection for cross-highlighting
  const handleItemSelect = (type: string, value: string) => {
    if (selectedItem.type === type && selectedItem.value === value) {
      // Deselect if clicking the same item
      setSelectedItem({
        type: null,
        value: null
      });
    } else {
      setSelectedItem({
        type,
        value
      });
    }
  };
  // Handle drilldown
  const handleDrilldown = (type: string, data: any) => {
    setDrilldownModal({
      type,
      data
    });
  };
  // Close drilldown modal
  const closeDrilldown = () => {
    setDrilldownModal({
      type: null,
      data: null
    });
  };
  // Handle navigation from TopBar buttons
  const handleNavigate = (section: string) => {
    setActiveSection(section);
  };
  // Determine if we should show KPI section
  const overviewPages = ['Overview', 'Sales Overview', 'Marketing Overview', 'Service Overview', 'Financial Overview', 'Supply Chain Overview', 'Plant Overview'];
  const showKPISection = overviewPages.includes(activeSection);
  return <>
      <DashboardLayout sidebar={<Sidebar activeSection={activeSection} setActiveSection={setActiveSection} data-id="element-1" />} topBar={<TopBar filters={filters} onFilterChange={handleFilterChange} activeSection={activeSection} onNavigate={handleNavigate} data-id="element-2" />} activeSection={activeSection} data-id="element-0">
        {showKPISection && <KPISection filters={filters} selectedItem={selectedItem} data-id="element-3" />}
        <ContentGrid activeSection={activeSection} filters={filters} selectedItem={selectedItem} onItemSelect={handleItemSelect} onDrilldown={handleDrilldown} data-id="element-4" />
      </DashboardLayout>

      {/* Drilldown Modals */}
      {drilldownModal.type === 'plant' && <PlantLevelView data={drilldownModal.data} onClose={closeDrilldown} data-id="element-5" />}
      {drilldownModal.type === 'customer' && <CustomerPLView data={drilldownModal.data} onClose={closeDrilldown} data-id="element-6" />}
      {drilldownModal.type === 'productLine' && <ProductLineBreakdown data={drilldownModal.data} onClose={closeDrilldown} data-id="element-7" />}
      {drilldownModal.type === 'warranty' && <WarrantyRootCauseView data={drilldownModal.data} onClose={closeDrilldown} data-id="element-8" />}
    </>;
}